<template>
  <filter-bar
    label="Active Pipeline"
    :filter-text="filterText"
    :reset="resetFilters"
  >
    <filter-item v-if="this.$store.getters.authUser.can_access_all_leads">
      <filter-users
        store-module="activeState"
        filter-name="active"
        @change="usersFilterText = $event"
      ></filter-users>
    </filter-item>

    <filter-item>
      <filter-campaigns
        store-module="activeState"
        filter-name="active"
        @change="campaignsFilterText = $event"
      ></filter-campaigns>
    </filter-item>


    <filter-item>
      <filter-exist-strategies
        store-module="activeState"
        filter-name="active"
        @change="exitStrategiesFilterText = $event"
      ></filter-exist-strategies>
    </filter-item>

    <filter-item>
      <filter-temperatures
        store-module="activeState"
        filter-name="active"
        @change="temperaturesFilterText = $event"
      ></filter-temperatures>
    </filter-item>

    <filter-item>
      <filter-deal-probability-score
        store-module="activeState"
        filter-name="active"
        @change="dealProbabilityScoreText = $event"
      ></filter-deal-probability-score>
    </filter-item>

    <filter-item>
      <filter-time-frames
        store-module="activeState"
        filter-name="active"
        @change="timeFramesFilterText = $event"
      ></filter-time-frames>
    </filter-item>

    <filter-item>
      <filter-lead-deal
        store-module="activeState"
        filter-name="active"
        @change="leadDealsFilterText = $event"
      ></filter-lead-deal>
    </filter-item>
  </filter-bar>
</template>

<script>
export default {
  name: "ActiveFilters",
  data() {
    return {
      usersFilterText: null,
      campaignsFilterText: null,
      temperaturesFilterText: null,
      dealProbabilityScoreText: null,
      exitStrategiesFilterText: null,
      timeFramesFilterText: null,
      leadDealsFilterText: null,
    };
  },
  computed: {
    filterText() {
      let array = [];

      if (this.usersFilterText) array.push(this.usersFilterText);
      if (this.campaignsFilterText) array.push(this.campaignsFilterText);
      if (this.temperaturesFilterText) array.push(this.temperaturesFilterText);
      if (this.dealProbabilityScoreText) array.push(this.dealProbabilityScoreText);
      if (this.exitStrategiesFilterText) array.push(this.exitStrategiesFilterText);
      if (this.timeFramesFilterText) array.push(this.timeFramesFilterText);
      if (this.leadDealsFilterText) array.push(this.leadDealsFilterText);

      return array.join(" | ");
    }
  },
  methods: {
    resetFilters() {
      this.usersFilterText = null;
      this.campaignsFilterText = null;
      this.temperaturesFilterText = null;
      this.dealProbabilityScoreText = null;
      this.exitStrategiesFilterText = null;
      this.timeFramesFilterText = null;
      this.leadDealsFilterText = null;

      this.$store.commit("activeState/resetFilters", "active");
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.filter_bar {
  padding-right: $defaultGap!important;
}
</style>
